import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import ArchiveList from './ArchiveList';

const ArchiveBrowse = () => {
  return (
    <Router>
      <Route component={ArchiveList} />
    </Router>
  );
};

export default ArchiveBrowse;
